import { NgModule } from '@angular/core';
import { ChangesControlTabsDirective } from './changes-control-tabs.directive';

@NgModule({
    declarations: [ChangesControlTabsDirective],
    exports: [ChangesControlTabsDirective],
})
export class ChangesWarningSharedModule {}
